export default "__VITE_ASSET__BzhHmR8I__"